import React, {useEffect, useState } from 'react' ;
import { useFormik } from "formik" ;
import * as Yup from 'yup';
import axios from 'axios';
import Swal from 'sweetalert2';
import {Link} from "react-router-dom";
// import logo from "../../../Assets/images/approved_logo.jpg"
import logo from "../../../Assets/slider_Online/home_online.jpg"
import { Fragment } from 'react';
// import logo from "../../../Assets/images/transportation.jpg"
import style from "./transformationOnline.module.css"
import { jwtDecode } from 'jwt-decode';




export default function TransformationOnline() {
   const [url , setUrl] = useState("") ;
   const [loading , setLoading] = useState(false) ;
   const [company , setCompany] = useState("") ;
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${localStorage.getItem("provider_token") }` 
   } ;

   //& Handle Phone Empty Or Email Empty :
   async function submitTransportation(values){
      setLoading(true)
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/onlineSystem/approval` , values , {headers:header})
      .then(({data})=>{
         if(data.message === "success"){
            setLoading(false)
            setUrl(data.url)
            Swal.fire({
               position: "top-center",
               icon: "success",
               title:  "Approved Successfully Please Print The PDF File Attention Appear File Only One !" ,
               showConfirmButton: true,
               timer: 10000
            });
         }
      })
      .catch((error)=>{
         setLoading(false)
         Swal.fire({
            title:error.response.data.message  ,
            text: "Please Try Again" ,   
            icon: "error"
         });
      })
   }



   let validationSchema = Yup.object({
      invoice_number:Yup.string().required().matches(/^[0-9]{10}$/ , "should be Invoice Number Contain 10 Number")
   })



   let formik = useFormik({
      initialValues:{
         invoice_number:"" ,
      } , validationSchema , 
      onSubmit:submitTransportation
   })



   useEffect(() => {
      const token = localStorage.getItem("provider_token")
      const decoded = jwtDecode(token);
      setCompany(decoded.company) ;
   }, [])
   
   return (

      <Fragment>
         <div className="container transformation">
            <h1 className='main-header mt-5 pt-5'>Transformation Online</h1>
            <div className='under-header'></div>  

            <div className="row m-0">
               <div className="col-md-12">
                  <div className='text-center my-2'>
                     <img src={logo} className={`rounded-2 w-100 ${style.cover}`} alt="approved"  />
                  </div>
               </div>


               <form  className='' onSubmit={formik.handleSubmit}>
                  <div className='d-flex align-items-center justify-content-between'>
                     <h3>{company?.name?.toUpperCase()}</h3>
                     <div className={`${style.image_logo}`}>
                        <img src={company?.logo} className='w-100' alt="logo"  />
                     </div>
                  </div>
                  <h4 className='text-center my-4'>Enter Your Invoice Number Please !</h4>
                  <div className="my-4 offset-md-2  col-md-8">
                     <label htmlFor="invoice_number" className="form-label">Enter Invoice Number</label>
                     <input type="text" 
                        value={formik.values.invoice_number}
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        className="form-control" id="invoice_number"  
                        name="invoice_number" 
                        placeholder="Enter Invoice Number [ 00-00-00-0000 ]"
                        maxLength={10}
                        />
                     {formik.errors.invoice_number && formik.touched.invoice_number?<div className="alert alert-danger mt-4 p-2">{formik.errors.invoice_number}</div> :""}
                  </div>

                  <div className="offset-md-2  col-md-8">
                     {loading? 
                        <button className="btn bg-main w-100"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                        :
                        <button disabled={!(formik.isValid && formik.dirty)} type="submit" className="btn w-100 bg-main text-white btn-sm mt-2">Send Invoice Number</button>
                     }
                     {url ? 
                        <>
                           <Link to={url} download target='_blank' className="btn w-50 btn-outline-primary btn-sm my-4">Download PDF Transform  <i className="fa-solid fa-file-pdf mx-4"></i> </Link>
                        </> : <></>}
                  </div>

               </form>

            </div>
         </div>
      </Fragment>

   )
}
